var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrustedShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_8200)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.76355L9.50011 0L19 3.76355V11.8041C19 18.9031 12.8795 22.0067 9.50011 22.9998C6.12054 22.0067 0 18.9031 0 11.8041V3.76355Z",
    fill: "url(#paint0_linear_78_8200)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_8200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.767822 4.38882L9.5001 0.929443L18.2324 4.38882V11.7796C18.2324 18.3049 12.6065 21.1575 9.5001 22.0704C6.39374 21.1575 0.767822 18.3047 0.767822 11.7796V4.38882Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_8200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2324 0.929443H0.767822V22.0704H18.2324V0.929443Z",
    fill: "#BAE13A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10208 0.907471H18.2546V22.092H0.745605V0.907471H7.10208Z",
    fill: "#BAE13A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07998 0.907471H18.2546V22.092H0.745605V0.907471H7.07998Z",
    fill: "#BAE13A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05788 0.907471H18.2546V22.092H0.745605V0.907471H7.05788Z",
    fill: "#B9E03A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03556 0.907471H18.2546V22.092H0.745605V0.907471H7.03556Z",
    fill: "#B8E03A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01347 0.907471H18.2546V22.092H0.745605V0.907471H7.01347Z",
    fill: "#B8E03A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99114 0.907471H18.2546V22.092H0.745605V0.907471H6.99114Z",
    fill: "#B7DF3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96905 0.907471H18.2546V22.092H0.745605V0.907471H6.96905Z",
    fill: "#B7DF3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94695 0.907471H18.2546V22.092H0.745605V0.907471H6.94695Z",
    fill: "#B6DF3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92463 0.907471H18.2546V22.092H0.745605V0.907471H6.92463Z",
    fill: "#B5DE3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90253 0.907471H18.2546V22.092H0.745605V0.907471H6.90253Z",
    fill: "#B4DE3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88021 0.907471H18.2546V22.092H0.745605V0.907471H6.88021Z",
    fill: "#B4DD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85811 0.907471H18.2546V22.092H0.745605V0.907471H6.85811Z",
    fill: "#B3DD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83602 0.907471H18.2546V22.092H0.745605V0.907471H6.83602Z",
    fill: "#B2DD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8137 0.907471H18.2546V22.092H0.745605V0.907471H6.8137Z",
    fill: "#B1DC3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7916 0.907471H18.2546V22.092H0.745605V0.907471H6.7916Z",
    fill: "#B1DC3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76928 0.907471H18.2546V22.092H0.745605V0.907471H6.76928Z",
    fill: "#B0DB3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74718 0.907471H18.2546V22.092H0.745605V0.907471H6.74718Z",
    fill: "#AFDB3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72508 0.907471H18.2546V22.092H0.745605V0.907471H6.72508Z",
    fill: "#AEDA3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70276 0.907471H18.2546V22.092H0.745605V0.907471H6.70276Z",
    fill: "#AEDA3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68066 0.907471H18.2546V22.092H0.745605V0.907471H6.68066Z",
    fill: "#ADD93A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65834 0.907471H18.2546V22.092H0.745605V0.907471H6.65834Z",
    fill: "#ACD93A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63625 0.907471H18.2546V22.092H0.745605V0.907471H6.63625Z",
    fill: "#ABD93A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61415 0.907471H18.2546V22.092H0.745605V0.907471H6.61415Z",
    fill: "#AAD83B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59183 0.907471H18.2546V22.092H0.745605V0.907471H6.59183Z",
    fill: "#A9D83B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56973 0.907471H18.2546V22.092H0.745605V0.907471H6.56973Z",
    fill: "#A9D73B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54741 0.907471H18.2546V22.092H0.745605V0.907471H6.54741Z",
    fill: "#A8D73B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52531 0.907471H18.2546V22.092H0.745605V0.907471H6.52531Z",
    fill: "#A7D63B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50322 0.907471H18.2546V22.092H0.745605V0.907471H6.50322Z",
    fill: "#A6D63B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48089 0.907471H18.2546V22.092H0.745605V0.907471H6.48089Z",
    fill: "#A5D53B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4588 0.907471H18.2546V22.092H0.745605V0.907471H6.4588Z",
    fill: "#A4D53B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43648 0.907471H18.2546V22.092H0.745605V0.907471H6.43648Z",
    fill: "#A3D43B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41438 0.907471H18.2546V22.092H0.745605V0.907471H6.41438Z",
    fill: "#A3D43B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39228 0.907471H16.9631H18.2546V22.092H0.745605V0.907471H6.39228Z",
    fill: "#A2D33B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36996 0.907471H16.8723H18.2546V22.092H0.745605V0.907471H6.36996Z",
    fill: "#A1D33B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34786 0.907471H16.7814H18.2546V22.092H0.745605V0.907471H6.34786Z",
    fill: "#A0D23B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32554 0.907471H16.6906H18.2546V22.092H0.745605V0.907471H6.32554Z",
    fill: "#9FD23B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30345 0.907471H16.6H18.2546V22.092H0.745605V0.907471H6.30345Z",
    fill: "#9ED13B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28135 0.907471H16.5091H18.2546V22.092H0.745605V0.907471H6.28135Z",
    fill: "#9DD13B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25903 0.907471H16.4183H18.2546V22.092H0.745605V0.907471H6.25903Z",
    fill: "#9CD03B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23693 0.907471H16.3274H18.2546V22.092H0.745605V0.907471H6.23693Z",
    fill: "#9BD03B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21461 0.907471H16.2366H18.2546V22.092H0.745605V0.907471H6.21461Z",
    fill: "#9ACF3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19251 0.907471H16.1457H18.2546V22.092H0.745605V0.907471H6.19251Z",
    fill: "#9ACF3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17041 0.907471H16.0549H18.2546V22.092H0.745605V0.907471H6.17041Z",
    fill: "#99CE3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14809 0.907471H15.964H18.2546V22.092H0.745605V0.907471H6.14809Z",
    fill: "#98CE3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.126 0.907471H15.8732H18.2546V22.092H0.745605V0.907471H6.126Z",
    fill: "#97CD3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10368 0.907471H15.7824H18.2546V22.092H0.745605V0.907471H6.10368Z",
    fill: "#96CD3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08158 0.907471H15.6915H18.2546V22.092H0.745605V0.907471H6.08158Z",
    fill: "#95CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05948 0.907471H15.6007H18.2546V22.092H0.745605V0.907471H6.05948Z",
    fill: "#94CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03716 0.907471H15.5098H18.2546V22.092H0.745605V0.907471H6.03716Z",
    fill: "#93CB3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01506 0.907471H15.419H18.2546V22.092H0.745605V0.907471H6.01506Z",
    fill: "#92CA3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99274 0.907471H15.3281H18.2546V22.092H0.745605V0.907471H5.99274Z",
    fill: "#91CA3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97064 0.907471H15.2375H18.2546V22.092H0.745605V0.907471H5.97064Z",
    fill: "#90C93B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94855 0.907471H15.1467H18.2546V22.092H0.745605V0.907471H5.94855Z",
    fill: "#8FC93B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92623 0.907471H15.0558H18.2546V22.092H0.745605V0.907471H5.92623Z",
    fill: "#8EC83B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90413 0.907471H14.965H18.2546V22.092H0.745605V0.907471H5.90413Z",
    fill: "#8DC83B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88181 0.907471H14.8741H18.2546V22.092H0.745605V0.907471H5.88181Z",
    fill: "#8CC73B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85971 0.907471H14.7833H18.2546V22.092H0.745605V0.907471H5.85971Z",
    fill: "#8BC73C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83761 0.907471H14.6924H18.2546V22.092H0.745605V0.907471H5.83761Z",
    fill: "#8AC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81529 0.907471H14.6016H18.2546V22.092H0.745605V0.907471H5.81529Z",
    fill: "#8AC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7932 0.907583H17.9408V0.783691C18.0115 0.84727 18.082 0.911284 18.1519 0.975734C18.222 1.04018 18.2916 1.10507 18.3608 1.17039H18.2546V22.0921H0.745605V0.907583H5.7932Z",
    fill: "#89C53C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77087 0.907546H17.7171V0.84375C17.7524 0.875104 17.7876 0.906458 17.8227 0.938029C17.893 1.00095 17.9629 1.06453 18.0323 1.12855C18.1017 1.19256 18.1709 1.25679 18.2396 1.32168C18.274 1.35412 18.3082 1.38656 18.3425 1.41922H18.2548V22.0923H0.745605V0.907546H5.7711H5.77087Z",
    fill: "#88C53C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74878 0.90753H17.4948V0.906006C17.6356 1.02924 17.7749 1.15422 17.9129 1.28116C18.0508 1.4081 18.187 1.53657 18.322 1.66699H18.2548V22.0923H0.745605V0.90753H5.74878Z",
    fill: "#87C43C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72668 0.907509H17.1682V0.879639C17.2388 0.939951 17.3091 1.00048 17.3789 1.06167C17.5187 1.18403 17.6568 1.30792 17.7937 1.43377C17.9305 1.55963 18.0658 1.68722 18.1995 1.81655C18.2664 1.88122 18.3327 1.94632 18.399 2.01186H18.255V22.092H0.745605V0.907509H5.72668Z",
    fill: "#86C33C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70436 0.907686H16.8424V0.859131C17.1254 1.0945 17.4026 1.33706 17.6738 1.5868C17.8095 1.71156 17.9437 1.83829 18.0762 1.96653C18.1425 2.03076 18.2086 2.09521 18.274 2.16032H18.2544V22.0924H0.745605V0.907686H5.70436Z",
    fill: "#85C33C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68226 0.907573H16.5183V0.843994C16.589 0.901476 16.6596 0.959394 16.7299 1.01775C17.0104 1.25116 17.2854 1.49176 17.5546 1.73932C17.8238 1.98689 18.087 2.24142 18.3441 2.5027H18.2548V22.0921H0.745605V0.907573H5.68226Z",
    fill: "#84C23C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65994 0.907632H16.1953V0.834473C16.3372 0.946606 16.4779 1.06048 16.6169 1.17632C16.8953 1.40777 17.168 1.64641 17.4347 1.89201C17.7017 2.13762 17.9626 2.38997 18.2178 2.64908C18.2816 2.71396 18.345 2.77906 18.4079 2.8446H18.2546V22.0922H0.745605V0.907632H5.66016H5.65994Z",
    fill: "#83C23C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63784 0.907645H15.8739V0.830566C15.9448 0.885218 16.0156 0.940305 16.0861 0.996045C16.227 1.10731 16.3663 1.22031 16.5044 1.33506C16.7805 1.56455 17.0508 1.80145 17.3156 2.04487C17.5803 2.28852 17.8392 2.53892 18.0921 2.79584C18.1553 2.86007 18.2182 2.92474 18.2807 2.98984H18.2548V22.0924H0.745605V0.907645H5.63784Z",
    fill: "#82C13C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61575 0.907559H15.554V0.831787C16.1232 1.25833 16.6709 1.71427 17.1959 2.1972C17.4584 2.43867 17.7151 2.68711 17.966 2.94186C18.0914 3.06923 18.2153 3.19835 18.3378 3.32899H18.2548V22.0921H0.745605V0.907559H5.61575Z",
    fill: "#81C13C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59343 0.907671H15.2357V0.838867C15.3069 0.890906 15.3779 0.943162 15.4484 0.996072C16.0127 1.41913 16.556 1.87115 17.0765 2.35017C17.3368 2.58967 17.5914 2.83593 17.8401 3.08851C17.9644 3.21479 18.0874 3.34282 18.2088 3.47237C18.2695 3.53704 18.3298 3.60236 18.3898 3.6679H18.2548V22.0922H0.745605V0.907671H5.59343Z",
    fill: "#80C03C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57133 0.907468H14.919V0.851074C15.0614 0.952321 15.2027 1.05531 15.3426 1.16026C15.9022 1.57962 16.4408 2.02793 16.9571 2.50281C17.2151 2.74036 17.4676 2.98444 17.7142 3.23484C17.8374 3.36003 17.9593 3.48697 18.0798 3.61544C18.1401 3.67967 18.1999 3.74434 18.2593 3.80922H18.255V22.092H0.745605V0.907468H5.57133Z",
    fill: "#7FC03C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54901 0.907653H14.604V0.868896C14.6752 0.918105 14.7462 0.967966 14.817 1.01804C14.9583 1.11842 15.0982 1.22054 15.2371 1.32462C15.792 1.74049 16.3259 2.18489 16.8377 2.65563C17.3495 3.12659 17.8388 3.6239 18.3044 4.14559H18.255V22.0924H0.745605V0.907653H5.54923H5.54901Z",
    fill: "#7EBF3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52691 0.907523H14.2909V0.891846C14.5759 1.08345 14.8563 1.28268 15.1313 1.48866C15.6812 1.90083 16.2107 2.34153 16.718 2.80835C17.2254 3.27517 17.7104 3.76813 18.172 4.28546C18.2296 4.35013 18.287 4.41523 18.3439 4.48055H18.2546V22.0923H0.745605V0.907523H5.52691Z",
    fill: "#7DBE3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50481 0.907589H13.765V0.781738C13.9088 0.873187 14.0514 0.966378 14.1927 1.06131C14.4753 1.25139 14.7531 1.44866 15.0257 1.6529C15.571 2.06158 16.0957 2.49836 16.5986 2.96105C17.1015 3.42373 17.5825 3.91255 18.0401 4.42532C18.1544 4.55356 18.2673 4.68311 18.3787 4.81419H18.2548V22.0921H0.745605V0.907589H5.50481Z",
    fill: "#7CBE3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48249 0.90771H13.4554V0.819092C13.5273 0.86351 13.5987 0.908363 13.6701 0.953434C13.8126 1.04401 13.9538 1.13633 14.094 1.23061C14.3741 1.41895 14.6496 1.61448 14.9197 1.81719C15.46 2.22218 15.9803 2.65525 16.4788 3.1138C16.9772 3.57257 17.4539 4.05703 17.9075 4.56522C18.0209 4.69238 18.1327 4.82084 18.2432 4.95083C18.2983 5.01572 18.3532 5.08125 18.4077 5.14679H18.2544V22.0922H0.745605V0.90771H5.48249Z",
    fill: "#7BBD3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46039 0.907514H13.1483V0.861572C14.2969 1.55005 15.3712 2.35719 16.3593 3.26646C16.8535 3.72109 17.3258 4.20119 17.7754 4.70503C17.8876 4.83088 17.9986 4.95826 18.1082 5.08715C18.1628 5.1516 18.2173 5.21627 18.2713 5.28137H18.2546V22.092H0.745605V0.907514H5.46039Z",
    fill: "#7ABD3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43807 0.90755H12.6271V0.7854C12.7717 0.867051 12.915 0.950444 13.0574 1.0358C14.1958 1.71818 15.2605 2.51814 16.2399 3.41912C16.7296 3.86962 17.1979 4.34559 17.6434 4.84485C17.8662 5.09438 18.0832 5.34978 18.2943 5.61084H18.2548V22.0923H0.745605V0.90755H5.4383H5.43807Z",
    fill: "#79BC3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41598 0.907553H12.3244V0.841797C12.3965 0.881207 12.4686 0.92127 12.5403 0.961769C12.6836 1.04255 12.8258 1.12529 12.9668 1.20999C14.0949 1.88627 15.15 2.67883 16.1205 3.57198C16.6058 4.01855 17.0698 4.49016 17.5113 4.98486C17.7321 5.23221 17.947 5.48543 18.1564 5.74388C18.2086 5.80855 18.2606 5.87365 18.3122 5.93897H18.2548V22.0923H0.745605V0.907553H5.41598Z",
    fill: "#78BC3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39388 0.907701H12.0242V0.903564C12.3126 1.05641 12.5965 1.21667 12.876 1.38432C13.9938 2.05451 15.0393 2.83988 16.0011 3.72476C16.4819 4.16719 16.9417 4.63445 17.3792 5.12479C17.5979 5.36996 17.8111 5.62079 18.0184 5.87707C18.122 6.00531 18.2242 6.13465 18.3251 6.26551H18.255V22.0924H0.745605V0.907701H5.39388Z",
    fill: "#77BB3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37156 0.9076H11.5093V0.860352C11.6541 0.932422 11.7981 1.00623 11.941 1.08201C12.2267 1.23355 12.5079 1.39228 12.7849 1.55841C13.8925 2.22228 14.9286 3.00069 15.8812 3.87729C16.3576 4.31559 16.8133 4.77871 17.2468 5.26448C17.4635 5.50725 17.6747 5.75591 17.88 6.00978C17.9827 6.13672 18.0841 6.26519 18.1838 6.39474C18.2338 6.45963 18.2834 6.52473 18.3325 6.59027H18.2546V22.0923H0.745605V0.9076H5.37156Z",
    fill: "#76BA3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34946 0.907664H10.9964V0.832764C11.5792 1.10319 12.1454 1.40366 12.6943 1.73266C14.8891 3.04822 16.7997 4.81666 18.3356 6.91345H18.2548V22.0922H0.745605V0.907664H5.34946Z",
    fill: "#75BA3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32714 0.907598H10.4852V0.820068C10.6316 0.883212 10.7769 0.948314 10.9211 1.01538C11.4984 1.28319 12.0595 1.58105 12.603 1.90678C14.7773 3.21015 16.67 4.96204 18.1916 7.03923C18.2392 7.10412 18.2863 7.16944 18.3332 7.23498H18.2544V22.0923H0.745605V0.907598H5.32736H5.32714Z",
    fill: "#74B93C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30504 0.907618H9.97675V0.822266C10.2705 0.939843 10.5604 1.06504 10.8464 1.19786C11.4182 1.46328 11.974 1.75809 12.5124 2.08099C14.6661 3.37216 16.541 5.10729 18.0483 7.1651C18.1425 7.29378 18.2354 7.42356 18.3267 7.55463H18.2546V22.0924H0.745605V0.907618H5.30504Z",
    fill: "#73B93C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28295 0.907506H9.47097V0.839355C9.61828 0.893789 9.76471 0.950183 9.91024 1.00832C10.2013 1.12481 10.4883 1.24892 10.7716 1.38021C11.3381 1.64302 11.8885 1.93522 12.4218 2.25485C14.5549 3.53361 16.4122 5.25241 17.905 7.29041C17.9983 7.41778 18.0903 7.54646 18.1807 7.67623C18.226 7.74112 18.2709 7.80644 18.3153 7.87198H18.2548V22.092H0.745605V0.907506H5.28295Z",
    fill: "#72B83C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26062 0.907482H8.96786V0.871338C10.15 1.27175 11.2745 1.79606 12.3309 2.42923C14.4436 3.6958 16.283 5.39805 17.7615 7.41645C17.9463 7.66881 18.1256 7.92595 18.2988 8.18789H18.2548V22.092H0.745605V0.907482H5.26062Z",
    fill: "#71B83C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23853 0.907682H8.02147V0.786621C8.32101 0.870231 8.6172 0.96168 8.90983 1.06075C10.0803 1.45724 11.1941 1.97654 12.2401 2.60362C14.3322 3.85777 16.1538 5.54348 17.6178 7.54228C17.8008 7.79224 17.9783 8.04699 18.1499 8.30632C18.2358 8.43609 18.3202 8.56695 18.403 8.69889H18.2546V22.0922H0.745605V0.907682H5.23853Z",
    fill: "#70B73C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21621 0.9076H7.52439V0.860352C7.67438 0.897802 7.82348 0.937212 7.97191 0.978582C8.26856 1.06132 8.56185 1.1519 8.85157 1.2501C10.0107 1.64267 11.1135 2.15675 12.1492 2.77773C14.2208 4.01969 16.0245 5.68884 17.4743 7.66805C17.6555 7.9154 17.8312 8.16776 18.0012 8.42468C18.0863 8.55315 18.1698 8.6827 18.2519 8.81334C18.293 8.87866 18.3336 8.94442 18.374 9.01017H18.2548V22.0921H0.745605V0.9076H5.21643H5.21621Z",
    fill: "#6FB63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19411 0.907589H6.12176V0.773682C6.428 0.823761 6.73133 0.881896 7.03154 0.948087C7.63197 1.08047 8.21967 1.24486 8.79331 1.43908C9.94082 1.82774 11.0327 2.3368 12.0584 2.95168C14.1094 4.18123 15.8953 5.83406 17.3307 7.79368C17.6897 8.28358 18.0265 8.79264 18.3403 9.31913H18.2548V22.0921H0.745605V0.907589H5.19411Z",
    fill: "#6DB63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17183 0.845459C10.1154 1.37456 14.3449 4.0392 17.187 7.91923C17.5424 8.40435 17.8758 8.90819 18.1865 9.42944C18.2254 9.49455 18.2638 9.56008 18.3019 9.62562H18.2546V22.0918H0.745643V0.981326H0.628906C0.923985 0.931682 1.22085 0.889877 1.5195 0.856128V0.907513H5.17205V0.845677L5.17183 0.845459Z",
    fill: "#6CB53D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14975 1.04288C10.0433 1.56675 14.2302 4.20439 17.0435 8.04524C17.3953 8.52534 17.7254 9.02417 18.0328 9.5402C18.1096 9.6691 18.185 9.79931 18.2591 9.93039H18.2546V22.0922H0.745665V1.17722H0.652588C0.944542 1.12801 1.2385 1.08664 1.53425 1.05311C2.7168 0.919205 3.92636 0.911802 5.14975 1.04266V1.04288Z",
    fill: "#6BB53D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12768 1.24003C9.97125 1.75845 14.1155 4.36931 16.9003 8.17097C17.2482 8.64628 17.5752 9.14011 17.8795 9.6507C18.0317 9.9061 18.1781 10.1656 18.319 10.4291H18.2549V22.0921H0.745687V1.37306H0.67627C0.965322 1.32451 1.25638 1.28336 1.54901 1.25026C2.7195 1.11766 3.91678 1.11048 5.12768 1.24003Z",
    fill: "#6AB43D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10538 1.43726C9.89896 1.95047 14.0006 4.53411 16.7565 8.29679C17.1009 8.7671 17.4246 9.25591 17.7257 9.76127C17.8764 10.0141 18.0212 10.2708 18.1605 10.5316C18.2301 10.662 18.2984 10.7933 18.3652 10.9257H18.2547V22.092H0.745709V1.56878H0.699951C0.986102 1.52066 1.27404 1.48016 1.56354 1.44728C2.72198 1.31599 3.90698 1.3088 5.10538 1.43705V1.43726Z",
    fill: "#69B33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08308 1.63458C9.82688 2.14234 13.8857 4.6992 16.6128 8.42269C17.2947 9.3535 17.8933 10.3573 18.3985 11.42H18.2545V22.0921H0.745507V1.76478H0.723633C1.00666 1.7171 1.29169 1.67704 1.57829 1.64459C2.72468 1.51482 3.89718 1.50764 5.0833 1.63458H5.08308Z",
    fill: "#68B33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06095 1.8316C9.75476 2.33413 13.7707 4.86399 16.4693 8.54807C17.144 9.46909 17.7362 10.4622 18.2362 11.5141C18.2674 11.5798 18.2982 11.6458 18.3288 11.712H18.2545V22.0921H0.7457V1.97857H0.642578C0.677622 1.97247 0.712442 1.96638 0.747485 1.9605C1.02761 1.91347 1.30952 1.87362 1.59321 1.84161C2.72755 1.71315 3.88778 1.70597 5.06117 1.8316H5.06095Z",
    fill: "#67B23D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03873 2.02897C9.68254 2.52605 13.6558 5.02914 16.3258 8.67402C16.9932 9.58524 17.5794 10.5679 18.074 11.6084C18.1358 11.7384 18.1963 11.8695 18.2552 12.0012H18.2548V22.0919H0.745582V2.17441H0.667236C0.701833 2.16832 0.73643 2.16244 0.771027 2.15656C1.04825 2.10996 1.32703 2.07055 1.6076 2.03876C2.72989 1.91161 3.87784 1.90464 5.03873 2.02897Z",
    fill: "#66B23D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01665 2.22612C9.61069 2.71798 13.5411 5.19406 16.1823 8.79976C16.8426 9.70118 17.4222 10.6731 17.9117 11.7026C18.0341 11.96 18.1508 12.2208 18.2617 12.4851H18.2548V22.092H0.7456V2.38811H0.589355C0.657657 2.3757 0.726181 2.36373 0.794705 2.35219C1.0688 2.30603 1.34491 2.26727 1.62235 2.2357C2.73258 2.10985 3.86803 2.1031 5.01665 2.2259V2.22612Z",
    fill: "#65B13D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99434 2.42352C9.53838 2.90994 13.4262 5.35924 16.0386 8.92574C16.6917 9.81736 17.2651 10.7789 17.749 11.797C17.991 12.3061 18.2106 12.8293 18.4068 13.3649H18.2544V22.0922H0.745608V2.58377H0.615479C0.68311 2.57136 0.750742 2.5596 0.818596 2.54828C1.08979 2.50255 1.36277 2.46423 1.63732 2.4331C2.73549 2.30877 3.85867 2.3018 4.99457 2.42352H4.99434Z",
    fill: "#64B13D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97223 2.62067C9.46627 3.10186 13.3114 5.52395 15.8953 9.05147C16.5412 9.9333 17.1084 10.8841 17.587 11.8912C17.8262 12.3946 18.0436 12.9121 18.2376 13.4419C18.286 13.5743 18.3331 13.7075 18.3787 13.8416H18.2548V22.0923H0.745595V2.77918H0.641357C0.708096 2.76699 0.775058 2.75523 0.842243 2.74391C1.11054 2.69884 1.38039 2.66073 1.65181 2.63003C2.73794 2.50701 3.84883 2.50026 4.97223 2.62045V2.62067Z",
    fill: "#63B03D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9499 2.81785C9.39394 3.2936 13.1965 5.6889 15.7515 9.17723C16.3903 10.0493 16.951 10.9897 17.4245 11.9854C17.6611 12.4833 17.876 12.995 18.0677 13.5189C18.1637 13.7808 18.2537 14.0458 18.338 14.3138H18.2546V22.0922H0.745582V2.97483H0.667236C0.733305 2.96286 0.799598 2.9511 0.86589 2.93999C1.13106 2.89536 1.39801 2.85769 1.66653 2.82743C2.7406 2.70571 3.839 2.69918 4.95012 2.81806L4.9499 2.81785Z",
    fill: "#62AF3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92779 3.01498C9.32205 3.48528 13.0817 5.85381 15.608 9.30273C16.8711 11.0272 17.826 13.0219 18.3976 15.1844H18.2545V22.0918H0.745569V3.17H0.693115C0.758515 3.15803 0.823914 3.14671 0.889537 3.1356C1.1518 3.0914 1.41563 3.05439 1.68125 3.02412C2.74304 2.90393 3.82939 2.89718 4.92801 3.01476L4.92779 3.01498Z",
    fill: "#61AF3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90568 3.21237C9.24994 3.67745 12.967 6.01897 15.4645 9.4287C16.7133 11.1336 17.6572 13.1056 18.2224 15.2435C18.2577 15.3772 18.2916 15.5113 18.324 15.6463H18.2548V22.0922H0.745556V3.36566H0.718994C0.783501 3.3539 0.848231 3.34258 0.913184 3.33169C1.17255 3.28814 1.43348 3.25135 1.69597 3.22152C2.74571 3.10263 3.81955 3.0961 4.90568 3.21237Z",
    fill: "#60AE3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88336 3.40963C9.17763 3.86927 12.8518 6.18401 15.3209 9.55455C16.5555 11.2398 17.4885 13.1892 18.0472 15.3025C18.1869 15.831 18.3032 16.3694 18.3947 16.9168H18.2545V22.0922H0.745564V3.56118H0.745117C0.808954 3.54964 0.873014 3.53832 0.937075 3.52765C1.19332 3.48453 1.45134 3.44817 1.71071 3.41878C2.74839 3.3012 3.80996 3.29467 4.88359 3.40963H4.88336Z",
    fill: "#5FAE3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86141 3.60651C9.1059 4.06093 12.7372 6.34867 15.1776 9.68001C16.3976 11.3457 17.3199 13.2724 17.8721 15.3612C18.0101 15.8833 18.125 16.4156 18.2156 16.9567C18.2609 17.2271 18.3002 17.4997 18.3333 17.7743H18.2547V22.0918H0.745708V3.77395H0.676514C0.707986 3.76807 0.739458 3.76219 0.771153 3.75631C0.834321 3.74477 0.897488 3.73367 0.960879 3.723C1.21422 3.68032 1.46912 3.6444 1.72558 3.61544C2.75122 3.49917 3.80051 3.49285 4.86163 3.60651H4.86141Z",
    fill: "#5EAD3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83898 3.80386C9.03347 4.25283 12.6222 6.51357 15.0337 9.80594C16.2395 11.452 17.1508 13.3561 17.6966 15.4202C17.9693 16.4523 18.1508 17.5246 18.2318 18.6246C18.3128 19.7246 18.2934 20.8527 18.1648 21.9965C18.1568 22.0679 18.1483 22.1393 18.1396 22.2105V22.0921H0.745594V3.98719H0.610107C0.734433 3.9628 0.859206 3.94016 0.984425 3.91904C1.23486 3.87702 1.48664 3.84152 1.7402 3.81278C2.75378 3.69804 3.79058 3.69172 4.8392 3.80386H4.83898Z",
    fill: "#5DAC3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81683 4.00109C8.96133 4.44483 12.5074 6.67858 14.8901 9.93176C16.0816 11.5582 16.982 13.4395 17.5213 15.4792C18.0606 17.5189 18.2382 19.717 17.984 21.9771C17.976 22.0476 17.9677 22.1182 17.959 22.1885V22.0918H0.745546V4.18225H0.638184C0.760947 4.15808 0.88438 4.13565 1.00804 4.11497C1.25535 4.07338 1.50445 4.03832 1.75466 4.01002C2.75619 3.89658 3.78071 3.89026 4.81683 4.00131V4.00109Z",
    fill: "#5CAC3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79469 4.19849C8.88918 4.63679 12.3926 6.84375 14.7468 10.0575C17.1009 13.2713 18.3056 17.4921 17.8034 21.9578C17.7956 22.0275 17.7873 22.0972 17.7786 22.1666V22.0919H0.745498V4.37747H0.66626C0.787684 4.35373 0.909332 4.33152 1.03165 4.31106C1.27606 4.2699 1.52203 4.23528 1.76935 4.2072C2.75882 4.09506 3.77106 4.08897 4.79469 4.19849Z",
    fill: "#5BAB3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77258 4.39558C8.81731 4.82866 12.2779 7.00862 14.6033 10.1832C16.9286 13.3578 18.1188 17.5272 17.6226 21.9385C17.6148 22.0075 17.6067 22.0761 17.5982 22.1449V22.092H0.745715V4.57217H0.694824C0.814686 4.54865 0.934994 4.52688 1.05575 4.50641C1.29704 4.46569 1.54011 4.43151 1.78452 4.40386C2.76194 4.29303 3.76168 4.28715 4.77303 4.39537L4.77258 4.39558Z",
    fill: "#5AAB3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75044 4.59279C8.74516 5.02043 12.1631 7.17361 14.4597 10.309C16.7563 13.4444 17.9319 17.5622 17.4417 21.9191C17.4341 21.9872 17.4261 22.0551 17.4176 22.1229V22.0919H0.745667V4.76742H0.7229C0.8412 4.74412 0.960169 4.72256 1.07936 4.70253C1.31775 4.66247 1.55769 4.62872 1.79898 4.60129C2.76435 4.49198 3.75181 4.48589 4.75044 4.59279Z",
    fill: "#58AA3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72814 4.78994C12.6178 5.63454 18.2288 13.2949 17.2607 21.8998C17.2531 21.9671 17.2453 22.0341 17.2369 22.101V22.092H0.745693V4.97981H0.66333C0.69257 4.97393 0.72181 4.96805 0.75105 4.96239C0.86801 4.93953 0.985417 4.91819 1.10305 4.89838C1.33853 4.85875 1.57535 4.82543 1.81374 4.79844C2.76705 4.69044 3.74224 4.68456 4.72837 4.79016L4.72814 4.78994Z",
    fill: "#57A93D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70583 4.98718C12.4955 5.82111 18.0355 13.3843 17.0797 21.8804C17.0724 21.9468 17.0643 22.013 17.0563 22.0792C17.0523 22.1123 17.048 22.1451 17.0438 22.1782V22.092H0.745482V5.19251H0.606201C0.663788 5.18053 0.721376 5.16877 0.778963 5.15745C0.894361 5.13481 1.0102 5.11368 1.1265 5.09409C1.35885 5.0549 1.593 5.02202 1.82826 4.99545C2.76952 4.88876 3.73221 4.88289 4.70606 4.98718H4.70583Z",
    fill: "#56A93D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6839 5.18444C12.3738 6.0077 17.8428 13.474 16.8993 21.861C16.8919 21.9265 16.8841 21.9918 16.8761 22.0572C16.8721 22.0898 16.8678 22.1223 16.8636 22.1549V22.092H0.745644V5.38694H0.636719C0.693413 5.37496 0.750331 5.36342 0.807472 5.35232C0.92153 5.32989 1.03581 5.3092 1.15054 5.28983C1.38 5.25129 1.61101 5.21863 1.84315 5.19228C2.77236 5.08711 3.72277 5.08124 4.6839 5.18422V5.18444Z",
    fill: "#55A83D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66149 5.38187C12.2514 6.19445 17.6494 13.5637 16.7182 21.842C16.7037 21.9713 16.6876 22.1002 16.6702 22.2285V22.0924H0.745561V5.58175H0.666992C0.723017 5.56999 0.779265 5.55867 0.835513 5.54756C0.948009 5.52557 1.06095 5.50489 1.17412 5.48594C1.40067 5.44784 1.62857 5.41583 1.8578 5.3897C2.77495 5.28584 3.71309 5.28018 4.66172 5.38165L4.66149 5.38187Z",
    fill: "#54A83D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63931 5.57888C12.1295 6.3808 17.4563 13.6531 16.5373 21.8223C16.523 21.9499 16.5072 22.0771 16.49 22.2036V22.0919H0.745478V5.77637H0.697266C0.752621 5.76483 0.807976 5.75351 0.863554 5.74262C0.974488 5.72084 1.08587 5.7006 1.19769 5.68187C1.42112 5.6442 1.64612 5.61263 1.87245 5.58694C2.77755 5.48438 3.70319 5.47872 4.63954 5.5791L4.63931 5.57888Z",
    fill: "#53A73D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61716 5.77603C12.0075 6.56707 17.2634 13.7427 16.3565 21.8029C16.3424 21.9287 16.3268 22.0541 16.3098 22.1791V22.092H0.74564V5.97091H0.727783C0.782246 5.95937 0.836931 5.94848 0.89184 5.93759C1.00143 5.91604 1.11125 5.89622 1.22152 5.8775C1.44204 5.84048 1.66391 5.80913 1.88734 5.78387C2.78039 5.68263 3.69375 5.67718 4.61738 5.77603H4.61716Z",
    fill: "#52A63D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.595 5.97335C11.8854 6.75371 17.0702 13.8323 16.1758 21.7837C16.1618 21.9081 16.1464 22.0317 16.1296 22.155V22.0923H0.745579V6.20045H0.596924C1.02615 6.10443 1.4614 6.03105 1.90179 5.98119C2.78278 5.88146 3.68365 5.87602 4.595 5.97357V5.97335Z",
    fill: "#51A63D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57303 6.17056C11.7636 6.94025 16.8775 13.9219 15.9952 21.7643C15.9813 21.8869 15.9662 22.0088 15.9496 22.1303V22.092H0.745706V6.39439H0.629639C1.05284 6.29968 1.48229 6.22717 1.91665 6.17796C2.78537 6.07955 3.67417 6.0741 4.57303 6.17034V6.17056Z",
    fill: "#50A53D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55059 6.36795C11.6412 7.12698 16.6841 14.0115 15.814 21.7451C15.8004 21.8659 15.7855 21.9863 15.7692 22.1061V22.0921H0.745589V6.58874H0.662109C1.07951 6.49533 1.50293 6.42391 1.93126 6.37536C2.78793 6.27825 3.66446 6.27302 4.55081 6.36795H4.55059Z",
    fill: "#4FA43D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52862 6.56489C11.5194 7.31325 16.4911 14.1009 15.6334 21.7253C15.62 21.8444 15.6052 21.9631 15.5892 22.0811C15.5851 22.1107 15.5811 22.1401 15.5769 22.1695V22.0916H0.745715V6.78263H0.694824C1.10642 6.69053 1.52381 6.6202 1.94612 6.5723C2.79073 6.47671 3.65476 6.47127 4.52862 6.56489Z",
    fill: "#4EA43D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50618 6.76229C11.397 7.49997 16.298 14.1905 15.4524 21.7063C15.4393 21.8237 15.4248 21.9406 15.4089 22.0571C15.4011 22.1152 15.3928 22.1734 15.3841 22.2313V22.0921H0.745598V6.97697H0.727295C1.13286 6.88618 1.54445 6.81672 1.96073 6.76969C2.79329 6.67541 3.64505 6.67018 4.5064 6.7625L4.50618 6.76229Z",
    fill: "#4DA33E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48408 6.95947C11.2751 7.68648 16.1049 14.2802 15.2716 21.6868C15.2587 21.8027 15.2442 21.9179 15.2288 22.0326C15.221 22.0899 15.2129 22.1471 15.2045 22.2044V22.092H0.745594V7.20551H0.610107C0.659882 7.19375 0.709657 7.18221 0.759656 7.1711C1.15942 7.08161 1.56498 7.01325 1.97524 6.96687C2.79574 6.8739 3.63522 6.86889 4.48408 6.95968V6.95947Z",
    fill: "#4CA33E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46207 7.15689C11.1534 7.87324 15.9119 14.3698 15.0909 21.6676C15.0782 21.7817 15.0639 21.8952 15.0485 22.0082C15.0409 22.0648 15.0329 22.1212 15.0244 22.1773V22.092H0.745686V7.39923H0.64502C0.694125 7.38747 0.74323 7.37615 0.792336 7.36526C1.18607 7.27708 1.58583 7.2098 1.99006 7.16386C2.79852 7.07219 3.62549 7.06718 4.46185 7.15689H4.46207Z",
    fill: "#4AA23E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4396 7.35375C11.0309 8.05943 15.7187 14.4591 14.91 21.648C14.8973 21.7604 14.8834 21.8723 14.8682 21.9836C14.8607 22.0393 14.8528 22.0948 14.8446 22.1504V22.092H0.745533V7.5926H0.679688C0.7279 7.58106 0.776336 7.56996 0.824995 7.55907C1.21293 7.47241 1.60666 7.40579 2.00486 7.36071C2.80126 7.27057 3.61597 7.26556 4.43982 7.35375H4.4396Z",
    fill: "#49A13E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41759 7.55117C10.9091 8.24618 15.5257 14.549 14.7293 21.6288C14.7168 21.7394 14.7032 21.8496 14.6882 21.9593C14.6808 22.0142 14.673 22.0689 14.665 22.1235V22.0922H0.745625V7.78632H0.7146C0.762143 7.775 0.809909 7.76411 0.857675 7.75345C1.2398 7.66809 1.62751 7.60256 2.01969 7.55814C2.80403 7.4693 3.60646 7.46451 4.41782 7.55117H4.41759Z",
    fill: "#48A13E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39514 7.74838C10.7867 8.4325 15.3325 14.6384 14.5481 21.6094C14.5359 21.7183 14.5225 21.8267 14.5077 21.9347C14.5004 21.9887 14.4928 22.0425 14.4847 22.0962V22.0919H0.745489V8.01423H0.608887C0.702187 7.99072 0.795934 7.96851 0.889904 7.94739C1.26601 7.86334 1.64791 7.79889 2.03406 7.75513C2.80635 7.6676 3.59628 7.66281 4.39536 7.74838H4.39514Z",
    fill: "#47A03E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3731 7.94556C10.6648 8.61901 15.1395 14.728 14.3674 21.5901C14.3433 21.8046 14.3143 22.0171 14.2806 22.2279V22.092H0.745546V8.20727H0.645996C0.737957 8.18419 0.830141 8.1622 0.922772 8.14152C1.29307 8.05878 1.66895 7.9952 2.04907 7.95231C2.80931 7.86608 3.58696 7.86151 4.37332 7.94556H4.3731Z",
    fill: "#46A03E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35104 8.1429C10.5428 8.80569 14.9464 14.8176 14.1869 21.5708C14.1632 21.7818 14.1346 21.9911 14.1014 22.1986V22.0923H0.745582V8.40026H0.682861C0.77326 8.37762 0.864105 8.35585 0.955173 8.3356C1.31967 8.25416 1.68952 8.19167 2.06339 8.14922C2.81158 8.06452 3.57673 8.05973 4.35081 8.14268L4.35104 8.1429Z",
    fill: "#459F3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32877 8.33986C10.4207 8.99198 14.7534 14.907 14.0059 21.5512C13.9824 21.7589 13.9545 21.9646 13.922 22.1686V22.0918H0.745639V8.59331H0.719971C0.80903 8.57088 0.898313 8.54976 0.987818 8.52973C1.34629 8.4496 1.71011 8.3882 2.07818 8.3464C2.81432 8.263 3.56719 8.25843 4.32877 8.33986Z",
    fill: "#449E3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30665 8.5372C10.2988 9.17865 14.5603 14.9965 13.8251 21.5321C13.8021 21.7363 13.7744 21.9388 13.7425 22.1395V22.0921H0.745615V8.82026H0.625977C0.669502 8.80872 0.71325 8.7974 0.756999 8.78629C0.844496 8.7643 0.932439 8.7434 1.02061 8.72359C1.37327 8.64477 1.73107 8.58423 2.09311 8.5433C2.81719 8.46121 3.55779 8.45686 4.30665 8.53699V8.5372Z",
    fill: "#439E3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28433 8.73442C10.1765 9.36519 14.367 15.0862 13.644 21.5126C13.6215 21.7134 13.5943 21.9126 13.5628 22.1099V22.092H0.745617V9.0129H0.665039C0.707895 9.00158 0.75075 8.99047 0.793829 8.97958C0.879987 8.95803 0.966368 8.93734 1.05297 8.91797C1.39983 8.84045 1.75161 8.78101 2.10762 8.74073C2.81965 8.66017 3.54775 8.6556 4.28433 8.73442Z",
    fill: "#429D3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26226 8.93181C10.0547 9.55192 14.1742 15.176 13.4635 21.4934C13.4414 21.6909 13.4146 21.8866 13.3836 22.0806C13.3758 22.1292 13.3677 22.1775 13.3595 22.2258V22.0924H0.745639V9.2055H0.704346C0.746532 9.1944 0.788718 9.18329 0.830904 9.17284C0.915499 9.1515 1.00032 9.13147 1.08558 9.11231C1.42642 9.0361 1.77239 8.97775 2.12238 8.93812C2.82235 8.85887 3.53817 8.85451 4.26226 8.93203V8.93181Z",
    fill: "#419C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24002 9.12894C9.93245 9.73838 13.981 15.2654 13.2826 21.4739C13.2607 21.6679 13.2346 21.8603 13.204 22.0509C13.1964 22.0985 13.1886 22.146 13.1803 22.1935V22.0918H0.745496V9.43159H0.619385C0.784334 9.38543 0.950623 9.34362 1.11825 9.30617C1.45328 9.23127 1.79323 9.17379 2.13719 9.13481C2.82511 9.05686 3.52866 9.05273 4.24024 9.12872L4.24002 9.12894Z",
    fill: "#409C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21791 9.32617C9.81057 9.92494 13.7879 15.355 13.1017 21.4547C13.0803 21.6452 13.0546 21.8344 13.0247 22.0216C13.0172 22.0685 13.0096 22.1153 13.0015 22.1619V22.0922H0.745707V9.62359H0.660889C0.822937 9.57831 0.986324 9.53715 1.15083 9.50036C1.48006 9.42676 1.81397 9.37037 2.15191 9.33205C2.82755 9.2554 3.51882 9.25127 4.21791 9.32617Z",
    fill: "#3E9B3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19578 9.52327C9.68844 10.1114 13.595 15.4444 12.9209 21.4351C12.8999 21.6224 12.8745 21.8079 12.8452 21.9919C12.8379 22.0378 12.8303 22.0837 12.8225 22.1295V22.0918H0.745674V9.81547H0.702148C0.861295 9.77105 1.02178 9.73055 1.18338 9.69441C1.50658 9.62212 1.8347 9.56682 2.16661 9.52915C2.8302 9.45403 3.50919 9.44989 4.19578 9.52327Z",
    fill: "#3D9B3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17342 9.72072C9.56631 10.2979 13.4017 15.5342 12.7401 21.4159C12.7193 21.5997 12.6945 21.7819 12.6658 21.9627C12.6512 22.053 12.6358 22.1429 12.6196 22.2324V22.0922H0.74564V10.0075H0.743408C0.899653 9.96371 1.05724 9.92408 1.21594 9.88859C1.53334 9.81761 1.85542 9.76318 2.1813 9.72638C2.83284 9.65257 3.49956 9.64843 4.17364 9.72072H4.17342Z",
    fill: "#3C9A3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15127 9.9179C9.44439 10.4844 13.2088 15.6236 12.5592 21.3967C12.5389 21.5772 12.5146 21.7559 12.4862 21.9332C12.4722 22.0218 12.457 22.11 12.4407 22.1979V22.0923H0.745589V10.2323H0.669922C0.70809 10.221 0.746482 10.2101 0.78465 10.1994C0.937993 10.1565 1.09267 10.1176 1.24847 10.0827C1.56007 10.013 1.87613 9.9597 2.19598 9.92356C2.83547 9.85105 3.48969 9.84714 4.15127 9.9179Z",
    fill: "#3B993E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12908 10.1149C9.3222 10.6708 13.0156 15.7131 12.3783 21.3771C12.3585 21.5541 12.3346 21.7296 12.3067 21.9036C12.2929 21.9904 12.2779 22.0771 12.262 22.1633V22.0921H0.745489V10.4572H0.601074C0.675625 10.4341 0.750623 10.4122 0.825843 10.3912C0.976284 10.3492 1.12806 10.3109 1.28096 10.2767C1.58653 10.2084 1.89679 10.1561 2.21062 10.1204C2.83805 10.0494 3.47999 10.0455 4.12908 10.1149Z",
    fill: "#3A993E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1069 10.3122C9.20024 10.8574 12.8224 15.8026 12.1977 21.3577C12.1783 21.5312 12.1546 21.7034 12.1274 21.8739C12.1138 21.9593 12.0992 22.0442 12.0836 22.1287V22.0919H0.74563V10.6479H0.646973C0.720184 10.6253 0.793619 10.6037 0.867501 10.583C1.01504 10.5417 1.16392 10.5042 1.31369 10.4707C1.61346 10.4036 1.91769 10.3522 2.22549 10.3174C2.84087 10.2477 3.47031 10.2438 4.10712 10.312L4.1069 10.3122Z",
    fill: "#39983E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0847 10.5096C9.07805 11.0441 12.6295 15.8924 12.0168 21.3387C11.9976 21.5089 11.9746 21.6777 11.948 21.8449C11.9346 21.9285 11.9204 22.0117 11.9052 22.0946V22.0924H0.745527V10.8388H0.692627C0.764276 10.8166 0.836372 10.7955 0.908691 10.7752C1.05333 10.7347 1.19931 10.6979 1.34618 10.6653C1.64014 10.5995 1.93834 10.5492 2.23989 10.515C2.84322 10.4467 3.46039 10.443 4.0847 10.5098V10.5096Z",
    fill: "#38983E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06249 10.7068C8.95607 11.2307 12.4363 15.9821 11.8359 21.3192C11.8171 21.486 11.7946 21.6515 11.7685 21.8152C11.7553 21.8971 11.7415 21.9788 11.7265 22.06C11.7191 22.1005 11.7113 22.141 11.7035 22.1815V22.0922H0.745647V11.0293H0.738281C0.808591 11.0077 0.879125 10.9868 0.950104 10.967C1.09184 10.9274 1.23492 10.8915 1.37888 10.8593C1.66682 10.7948 1.95922 10.7456 2.25475 10.7121C2.84602 10.645 3.45091 10.6413 4.06249 10.7068Z",
    fill: "#37973E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04039 10.9039C8.83397 11.4171 12.2432 16.0714 11.6551 21.2997C11.6368 21.463 11.6147 21.625 11.589 21.7857C11.5763 21.866 11.5624 21.9459 11.5479 22.0254C11.5406 22.0652 11.5332 22.1049 11.5254 22.1445V22.0922H0.745638V11.2525H0.680908C0.715282 11.2414 0.749656 11.2305 0.78403 11.2201C0.853 11.199 0.921971 11.1785 0.991612 11.1591C1.13045 11.1204 1.27062 11.0851 1.41169 11.0535C1.69382 10.9904 1.98019 10.942 2.26969 10.9094C2.84891 10.8438 3.4413 10.8401 4.04061 10.9044L4.04039 10.9039Z",
    fill: "#36963E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01823 11.1012C8.71204 11.6037 12.0503 16.1611 11.4744 21.2805C11.4385 21.6003 11.3881 21.915 11.324 22.2235V22.0922H0.74558V11.4757H0.628174C1.69778 11.1155 2.84484 10.9757 4.01823 11.1014V11.1012Z",
    fill: "#34963E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99594 11.2982C8.58998 11.7901 11.857 16.2504 11.2935 21.2609C11.2582 21.574 11.2089 21.8819 11.1461 22.1839V22.092H0.74561V11.6647H0.677979C1.72482 11.3122 2.84755 11.1754 3.99594 11.2984V11.2982Z",
    fill: "#33953E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97389 11.4957C8.46793 11.9768 11.6642 16.3403 11.1127 21.2417C11.0783 21.548 11.0299 21.8492 10.9685 22.1446V22.0922H0.745661V11.854H0.728027C1.7521 11.5092 2.85027 11.3755 3.97389 11.4957Z",
    fill: "#32943E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95144 11.6928C8.3457 12.1631 11.4708 16.4296 10.9315 21.2221C10.8978 21.5218 10.8507 21.8161 10.7907 22.1051V22.092H0.745523V12.1088H0.591064C0.653116 12.0862 0.71539 12.0642 0.777888 12.0433C1.77919 11.706 2.85304 11.5754 3.95166 11.693L3.95144 11.6928Z",
    fill: "#31943E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92952 11.89C8.22379 12.3497 11.2779 16.5193 10.7512 21.203C10.7181 21.4956 10.6721 21.7835 10.6134 22.0659C10.6061 22.1011 10.5985 22.1364 10.5909 22.1715V22.0922H0.745707V12.2968H0.645264C0.705753 12.2745 0.766688 12.2532 0.827847 12.2325C1.80638 11.9029 2.8559 11.7751 3.92952 11.89Z",
    fill: "#30933E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90739 12.0873C8.10188 12.5363 11.085 16.6088 10.5703 21.1836C10.5382 21.4695 10.4931 21.7506 10.4357 22.0262C10.4214 22.0953 10.4063 22.1639 10.3904 22.232V22.092H0.745667V12.4842H0.699463C0.758613 12.4627 0.818209 12.4418 0.877805 12.4215C1.83357 12.0997 2.85854 11.9747 3.90716 12.0871L3.90739 12.0873Z",
    fill: "#2F923E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88498 12.2845C7.97948 12.7228 10.8917 16.6984 10.3892 21.1642C10.3577 21.4433 10.3138 21.7176 10.258 21.9868C10.2439 22.054 10.2292 22.1209 10.2138 22.1875V22.0919H0.745582V12.7043H0.667236C0.69603 12.6934 0.724824 12.6825 0.753617 12.6721C0.811428 12.6509 0.869461 12.6305 0.927718 12.6109C1.86072 12.2967 2.86136 12.1748 3.88498 12.2843V12.2845Z",
    fill: "#2E923F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86297 12.4818C7.8577 12.9095 10.6987 16.7882 10.2085 21.1451C10.1779 21.4175 10.1348 21.6851 10.0804 21.9477C10.0668 22.0132 10.0525 22.0785 10.0373 22.1436V22.0922H0.745672V12.9241H0.639648C0.751252 12.8799 0.863971 12.8387 0.977806 12.8004C1.88804 12.4938 2.86435 12.3749 3.86297 12.4818Z",
    fill: "#2D913F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84052 12.6789C7.73547 13.0959 10.5055 16.8775 10.0276 21.1255C9.99767 21.3909 9.95593 21.652 9.90281 21.9081C9.88942 21.9721 9.87558 22.0357 9.86084 22.099V22.092H0.745541V13.11H0.697998C0.806923 13.0669 0.91674 13.0269 1.02767 12.9894C1.91514 12.6905 2.86712 12.5746 3.84074 12.6789H3.84052Z",
    fill: "#2C913F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81857 12.8761C7.61352 13.2824 10.3125 16.9671 9.84693 21.106C9.81791 21.3647 9.77706 21.619 9.72528 21.8686C9.69939 21.9933 9.67082 22.1168 9.63934 22.2389V22.092H0.745684V13.361H0.598145C0.650598 13.3388 0.703498 13.317 0.756398 13.2961C0.862421 13.2543 0.96956 13.2151 1.07759 13.1785C1.94229 12.8872 2.86972 12.7744 3.81857 12.8759V12.8761Z",
    fill: "#2A903F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79647 13.0732C7.49165 13.4688 10.1195 17.0564 9.66613 21.0867C9.63778 21.3386 9.59805 21.5862 9.54761 21.8292C9.52239 21.9507 9.49448 22.0709 9.46391 22.1898V22.092H0.745686V13.5455H0.660645C0.711759 13.5237 0.763096 13.5028 0.814657 13.4823C0.918002 13.4416 1.02224 13.4033 1.12737 13.368C1.9693 13.0845 2.8724 12.9746 3.79625 13.0734L3.79647 13.0732Z",
    fill: "#298F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77417 13.2705C7.36936 13.6554 9.92641 17.1462 9.48513 21.0673C9.45746 21.3125 9.41884 21.5533 9.36996 21.7896C9.34541 21.9078 9.31818 22.0247 9.28849 22.1406V22.092H0.745709V13.7299H0.723389C0.773164 13.7088 0.823162 13.6883 0.873383 13.6685C0.973826 13.6289 1.07539 13.5916 1.17784 13.5572C1.997 13.2814 2.87577 13.1742 3.77462 13.2705H3.77417Z",
    fill: "#288F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75198 13.4678C7.2474 13.8421 9.73325 17.2357 9.30447 21.048C9.27768 21.2862 9.24018 21.5205 9.19242 21.7502C9.16853 21.8652 9.1422 21.9788 9.1134 22.0914C9.10626 22.1195 9.09889 22.1476 9.0913 22.1757V22.0921H0.745616V13.9779H0.641602C0.832889 13.8909 1.02842 13.8136 1.22752 13.7465C2.02392 13.4782 2.87813 13.3742 3.75198 13.4678Z",
    fill: "#278E3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72955 13.6652C7.12497 14.0286 9.54006 17.3256 9.12334 21.029C9.09722 21.2605 9.06084 21.488 9.01441 21.7112C8.9912 21.8227 8.96553 21.9333 8.93763 22.0426C8.92357 22.0972 8.90906 22.1517 8.89388 22.2057V22.0922H0.745507V14.1608H0.708008C0.893939 14.0763 1.08389 14.0012 1.27718 13.9359C2.05082 13.6752 2.8807 13.5742 3.72955 13.665V13.6652Z",
    fill: "#268D3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70744 13.862C7.00308 14.2148 9.34697 17.4148 8.94252 21.0092C8.9173 21.2339 8.88181 21.4547 8.83695 21.6713C8.8144 21.7795 8.78963 21.8869 8.7624 21.9929C8.74878 22.0461 8.73449 22.0987 8.71976 22.1512V22.0918H0.74549V14.4062H0.640137C0.684778 14.3846 0.729642 14.3635 0.77473 14.3428C0.955081 14.2607 1.13945 14.1878 1.32717 14.1246C2.07803 13.8716 2.88358 13.7737 3.70744 13.8618V13.862Z",
    fill: "#258D3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68539 14.0594C6.88126 14.4014 9.15394 17.5044 8.76199 20.9899C8.73744 21.2076 8.70307 21.4219 8.65954 21.632C8.63767 21.7369 8.61356 21.841 8.58722 21.944C8.57405 21.9954 8.56021 22.0465 8.54593 22.0975V22.0921H0.745535V14.5872H0.710938C0.75424 14.5663 0.797765 14.5458 0.84129 14.5258C1.01628 14.4461 1.19485 14.3755 1.37699 14.3141C2.10531 14.069 2.88608 13.9738 3.68516 14.0594H3.68539Z",
    fill: "#248C3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66313 14.2568C6.759 14.5882 8.96093 17.5942 8.58103 20.9706C8.53349 21.3926 8.448 21.8007 8.32859 22.1906V22.092H0.745595V14.8305H0.656982C0.739792 14.7876 0.823494 14.7469 0.908313 14.7084C1.07773 14.6313 1.25093 14.5627 1.42727 14.5035C2.13282 14.2659 2.88927 14.1738 3.66335 14.2566L3.66313 14.2568Z",
    fill: "#228B3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64096 14.454C6.63706 14.7747 8.76779 17.6837 8.40017 20.9514C8.35419 21.3599 8.27138 21.7546 8.15576 22.132V22.0921H0.745528V15.0094H0.731689C0.811821 14.9681 0.892845 14.9287 0.974984 14.8912C1.13904 14.8165 1.30645 14.7503 1.4772 14.6928C2.15999 14.4629 2.8921 14.3736 3.64119 14.454H3.64096Z",
    fill: "#218B3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61874 14.6512C6.51484 14.9612 8.57459 17.7733 8.21925 20.9319C8.17483 21.3267 8.0947 21.7084 7.98309 22.0733C7.96903 22.1188 7.95475 22.1643 7.93979 22.2094V22.0923H0.745625V15.2497H0.691162C0.72933 15.2288 0.767945 15.2081 0.80656 15.1881C0.884013 15.148 0.962358 15.1099 1.0416 15.0738C1.20007 15.0017 1.36212 14.9375 1.52707 14.882C2.18709 14.6597 2.89488 14.5734 3.61874 14.6509V14.6512Z",
    fill: "#208A3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59662 14.8482C6.39295 15.1476 8.38172 17.8626 8.03865 20.9124C7.99579 21.2936 7.91856 21.662 7.81053 22.0143C7.79714 22.0583 7.78308 22.1021 7.76857 22.1456V22.0919H0.745602V15.4882H0.659668C0.951399 15.3186 1.25831 15.1783 1.57705 15.071C2.2143 14.8563 2.89754 14.7731 3.59662 14.848V14.8482Z",
    fill: "#1F8A3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57447 15.0454C6.27081 15.3342 8.1886 17.9522 7.85781 20.8932C7.81651 21.2607 7.74196 21.616 7.63795 21.9557C7.61183 22.0406 7.58416 22.1247 7.55447 22.2074V22.092H0.745557V15.6627H0.742432C1.02367 15.4992 1.31987 15.364 1.627 15.2606C2.24149 15.0537 2.90039 14.9734 3.57447 15.0454Z",
    fill: "#1E893F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55209 15.2428C6.14865 15.5208 7.99523 18.0418 7.67672 20.8738C7.63699 21.2279 7.56511 21.5699 7.4649 21.897C7.4399 21.9788 7.41311 22.0596 7.38454 22.1395V22.0921H0.74549V15.9604H0.624512C0.690358 15.9177 0.75732 15.8766 0.824951 15.8372C1.0957 15.6798 1.38096 15.5496 1.67671 15.4498C2.26843 15.2506 2.903 15.1733 3.55209 15.2428Z",
    fill: "#1D883F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53017 15.4401C6.02695 15.7075 7.80256 18.1316 7.4961 20.8546C7.45771 21.1949 7.38874 21.5239 7.29253 21.8385C7.26843 21.9171 7.24276 21.9948 7.21531 22.0717C7.20169 22.11 7.1874 22.1483 7.1729 22.1862V22.0924H0.745667V16.1304H0.715088C0.778479 16.0892 0.842762 16.0498 0.907715 16.0119C1.1682 15.8604 1.44229 15.7354 1.72666 15.6396C2.29561 15.448 2.90564 15.3737 3.52994 15.4406L3.53017 15.4401Z",
    fill: "#1C883F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50777 15.6373C5.90456 15.8938 7.60919 18.2212 7.31523 20.8353C7.2784 21.1621 7.21211 21.4778 7.1197 21.7798C7.0735 21.9307 7.0206 22.0783 6.96167 22.222V22.0923H0.745594V16.4227H0.625732C0.743809 16.3377 0.865456 16.2587 0.990452 16.186C1.24044 16.0405 1.5036 15.9206 1.77681 15.8285C2.32299 15.6445 2.90869 15.5733 3.508 15.6373H3.50777Z",
    fill: "#1B873F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48559 15.8345C5.78261 16.0803 7.41625 18.3105 7.13435 20.8158C7.09908 21.1289 7.03569 21.4316 6.94707 21.7209C6.90266 21.8655 6.85221 22.007 6.79574 22.1446V22.092H0.745507V16.587H0.723633C0.836798 16.5055 0.953312 16.4298 1.07317 16.3601C1.31267 16.2207 1.5649 16.1055 1.82672 16.0176C2.35014 15.8412 2.9115 15.7728 3.48581 15.8345H3.48559Z",
    fill: "#19863F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46355 16.0316C5.66057 16.2668 7.22324 18.4002 6.95361 20.7963C6.9199 21.0959 6.85919 21.3853 6.77437 21.662C6.73196 21.8005 6.68353 21.9357 6.62951 22.0675C6.6159 22.1003 6.60206 22.133 6.588 22.1657V22.0921H0.745568V16.8725H0.661865C0.714319 16.8309 0.767442 16.7907 0.821458 16.7517C0.929713 16.6737 1.04132 16.6012 1.15582 16.5346C1.38505 16.4014 1.62634 16.2912 1.87655 16.2069C2.37721 16.0384 2.91424 15.9728 3.46333 16.0316H3.46355Z",
    fill: "#18863F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44118 16.229C5.53843 16.4535 7.02989 18.4897 6.77254 20.7772C6.7404 21.0631 6.68236 21.3394 6.60156 21.6038C6.56116 21.7359 6.51496 21.8648 6.4634 21.9907C6.4375 22.0536 6.4105 22.1157 6.38215 22.1766V22.0921H0.745517V17.1546H0.619629C1.39103 16.4787 2.39256 16.1166 3.44118 16.229Z",
    fill: "#17853F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41912 16.4262C5.41659 16.64 6.83707 18.5794 6.59199 20.7578C6.56141 21.0302 6.50606 21.2932 6.42905 21.5449C6.39044 21.6708 6.34647 21.7936 6.29736 21.9133C6.27281 21.9732 6.24692 22.0322 6.21991 22.0906C6.20629 22.1198 6.19245 22.1487 6.17839 22.1772V22.0921H0.745549V17.3076H0.731934C1.46673 16.6637 2.42049 16.3191 3.41912 16.426V16.4262Z",
    fill: "#16843F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39689 16.6233C5.29437 16.8264 6.64388 18.6687 6.41107 20.7383C6.35282 21.2556 6.20126 21.7383 5.97694 22.1679V22.0919H0.745649V17.703H0.592529C0.672884 17.6179 0.757032 17.5371 0.844306 17.4607C1.54227 16.8491 2.44849 16.5216 3.39712 16.6233H3.39689Z",
    fill: "#15843F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37484 16.8205C5.17255 17.013 6.45085 18.7584 6.23032 20.7188C6.17519 21.209 6.03167 21.6662 5.81918 22.0734C5.79262 22.1243 5.76494 22.1744 5.73637 22.2236V22.0919H0.745695V17.8434H0.718018C0.794131 17.7629 0.873816 17.6862 0.956402 17.6137C1.61776 17.0343 2.47621 16.7241 3.37484 16.8203V16.8205Z",
    fill: "#14833F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35276 17.0179C5.05046 17.1997 6.25801 18.848 6.04954 20.6998C5.99753 21.1627 5.86182 21.5945 5.66116 21.979C5.63616 22.0271 5.61004 22.0744 5.58281 22.1209V22.0922H0.745706V18.2233H0.637451C0.768027 18.0567 0.912441 17.9041 1.06869 17.7673C1.69322 17.2202 2.5039 16.9271 3.35276 17.0181V17.0179Z",
    fill: "#13823F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3304 17.2151C4.92834 17.3862 6.06468 18.9376 5.8687 20.6804C5.8196 21.116 5.69215 21.5223 5.50309 21.8842C5.45577 21.9746 5.40488 22.0623 5.3502 22.147V22.0922H0.74567V18.5942H0.600586C0.655272 18.5095 0.713305 18.4279 0.774687 18.3495C0.897451 18.1927 1.03361 18.049 1.18048 17.9204C1.7684 17.4054 2.53132 17.1295 3.33018 17.2151H3.3304Z",
    fill: "#11823F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3083 17.4124C4.80623 17.5728 5.8716 19.0273 5.6879 20.661C5.64192 21.0694 5.52228 21.4505 5.34528 21.7897C5.30108 21.8746 5.25309 21.9567 5.20198 22.0362C5.17631 22.0758 5.14997 22.1148 5.12274 22.1531V22.0924H0.745663V18.9517H0.605713C0.782716 18.6125 1.01731 18.3151 1.29274 18.0736C1.84384 17.5909 2.55922 17.3322 3.3083 17.4124Z",
    fill: "#10813F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28599 17.6094C4.68416 17.759 5.67854 19.1166 5.5069 20.6416C5.46404 21.0228 5.35221 21.3784 5.18704 21.695C5.10445 21.8533 5.00847 22.0018 4.90089 22.139V22.0919H0.96576V22.1311C0.865317 21.9939 0.777151 21.8461 0.7026 21.6893H0.745679V19.2903H0.650146C0.68452 19.2065 0.722465 19.1248 0.763759 19.0458C0.928931 18.7292 1.1479 18.4516 1.40503 18.2263C1.9193 17.7755 2.58713 17.5343 3.28621 17.6092L3.28599 17.6094Z",
    fill: "#0F8140"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2637 17.8067C4.5621 17.9457 5.48528 19.2063 5.32613 20.6223C5.2864 20.9763 5.18261 21.3064 5.02904 21.6006C4.95226 21.7475 4.8632 21.8856 4.76321 22.013C4.71321 22.0765 4.66075 22.1377 4.60562 22.1959V22.0922H1.2573V22.1891C1.20507 22.1305 1.15574 22.0693 1.10909 22.0058C0.922492 21.751 0.781426 21.4564 0.697054 21.1368H0.74549V20.1191H0.624512C0.783881 18.7032 1.96531 17.6678 3.2637 17.807V17.8067Z",
    fill: "#0E8040"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2416 18.0039C4.43999 18.1322 5.29242 19.2958 5.14533 20.6028C5.07189 21.2565 4.7623 21.8219 4.32147 22.2082V22.0919H1.54144V22.203C1.43564 22.1056 1.33899 21.9972 1.25283 21.8796C0.908423 21.4093 0.73209 20.7916 0.805525 20.1382C0.952618 18.8311 2.0432 17.8755 3.2416 18.0037V18.0039Z",
    fill: "#0D7F40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21928 18.2013C4.3179 18.3189 5.09912 19.3855 4.9643 20.5837C4.8969 21.1827 4.6132 21.7014 4.2092 22.0554C4.15875 22.0996 4.1063 22.1414 4.05228 22.1804V22.0924H1.81263V22.1771C1.75995 22.1377 1.70929 22.0955 1.66085 22.0508C1.56375 21.9616 1.47514 21.8623 1.39635 21.7545C1.08051 21.3234 0.918912 20.7573 0.98632 20.1581C1.12114 18.9599 2.12088 18.0839 3.2195 18.2015L3.21928 18.2013Z",
    fill: "#0C7F40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19731 18.3985C4.19594 18.5054 4.90618 19.475 4.78364 20.5643C4.72248 21.1089 4.46446 21.5803 4.09706 21.9021C4.00532 21.9826 3.90644 22.0536 3.80243 22.1142V22.092H2.067V22.1124C1.86187 21.9894 1.68331 21.8241 1.53978 21.6282C1.25274 21.2363 1.10587 20.7215 1.16703 20.177C1.28957 19.0876 2.19847 18.2914 3.19709 18.3983L3.19731 18.3985Z",
    fill: "#0A7E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60271 20.5438C4.71294 19.5635 4.07367 18.6908 3.17485 18.5946C2.27603 18.4984 1.45803 19.2152 1.34779 20.1955C1.23756 21.1758 1.87683 22.0484 2.77565 22.1446C3.67447 22.2408 4.49247 21.5241 4.60271 20.5438Z",
    fill: "#097D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.422 20.5245C4.51999 19.6531 3.95175 18.8774 3.1528 18.7919C2.35385 18.7064 1.62674 19.3435 1.52875 20.2149C1.43076 21.0863 1.999 21.862 2.79795 21.9475C3.5969 22.033 4.32401 21.3959 4.422 20.5245Z",
    fill: "#087D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24105 20.505C4.3268 19.7425 3.82959 19.0637 3.13051 18.9889C2.43143 18.9141 1.7952 19.4716 1.70945 20.2341C1.62371 20.9966 2.12092 21.6754 2.82 21.7502C3.51908 21.825 4.15531 21.2675 4.24105 20.505Z",
    fill: "#077C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06033 20.4857C4.13381 19.8322 3.70763 19.2505 3.10841 19.1863C2.5092 19.1222 1.96387 19.6 1.89038 20.2535C1.8169 20.907 2.24308 21.4887 2.8423 21.5529C3.44151 21.617 3.98684 21.1392 4.06033 20.4857Z",
    fill: "#067B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87938 20.4664C3.94062 19.9218 3.58546 19.437 3.08612 19.3836C2.58678 19.3302 2.13233 19.7283 2.07109 20.2729C2.00985 20.8175 2.365 21.3023 2.86435 21.3558C3.36369 21.4092 3.81814 21.011 3.87938 20.4664Z",
    fill: "#057B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69867 20.4472C3.74767 20.0115 3.46355 19.6236 3.06407 19.5809C2.6646 19.5381 2.30104 19.8567 2.25204 20.2924C2.20305 20.7281 2.48717 21.116 2.88665 21.1587C3.28612 21.2014 3.64968 20.8829 3.69867 20.4472Z",
    fill: "#037A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51772 20.4274C3.55447 20.1006 3.34139 19.8097 3.04178 19.7776C2.74217 19.7456 2.4695 19.9845 2.43275 20.3113C2.396 20.6381 2.60909 20.9291 2.9087 20.9611C3.2083 20.9932 3.48097 20.7542 3.51772 20.4274Z",
    fill: "#027940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33699 20.4081C3.36149 20.1904 3.21942 19.9965 3.01968 19.9751C2.81994 19.9537 2.63817 20.113 2.61368 20.3307C2.58919 20.5485 2.73126 20.7424 2.93099 20.7638C3.13073 20.7852 3.3125 20.6259 3.33699 20.4081Z",
    fill: "#017940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15605 20.3884C3.16829 20.2795 3.09726 20.1826 2.99739 20.1719C2.89752 20.1612 2.80663 20.2408 2.79439 20.3497C2.78214 20.4586 2.85318 20.5555 2.95305 20.5662C3.05291 20.5769 3.1438 20.4973 3.15605 20.3884Z",
    fill: "#007840"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29623 10.3487H2.99151V7.48544H3.62854V6.85902H1.66455V7.48544H2.29623V10.3487ZM3.99483 10.3487H4.69011V8.95602H4.79614C5.02448 8.95602 5.13586 9.08035 5.19947 9.50994C5.25259 9.89838 5.33206 10.2505 5.38004 10.3487H6.10725C6.04341 10.2193 5.94811 9.78951 5.87913 9.40107C5.81016 9.02308 5.68807 8.80557 5.44388 8.70715V8.6967C5.80481 8.53623 5.99587 8.19961 5.99587 7.82685C5.99587 7.52659 5.9269 7.29362 5.70927 7.10201C5.48093 6.90017 5.13608 6.84312 4.75395 6.84312C4.48856 6.84312 4.21268 6.86903 3.99505 6.9104V10.3484L3.99483 10.3487ZM4.69011 7.39225C4.72717 7.37679 4.79614 7.37157 4.85997 7.37157C5.16778 7.38202 5.28987 7.58908 5.28987 7.88934C5.28987 8.1896 5.12001 8.43281 4.81757 8.43281H4.69011V7.39225ZM6.46818 6.85902V9.01285C6.46818 9.88793 6.76013 10.39 7.50854 10.39C8.19312 10.39 8.54355 9.90339 8.54355 9.00763V6.8588H7.84826V9.12651C7.84826 9.65452 7.70496 9.79452 7.50318 9.79452C7.31748 9.79452 7.16346 9.63928 7.16346 9.12651V6.8588H6.46818V6.85902ZM8.96273 10.24C9.08483 10.3073 9.36093 10.3798 9.64753 10.3798C10.3428 10.3798 10.8258 9.96043 10.8258 9.32356C10.8258 8.95602 10.656 8.60395 10.1783 8.32416C9.79618 8.0964 9.68994 7.98776 9.68994 7.78047C9.68994 7.59409 9.83324 7.41816 10.1305 7.41816C10.327 7.41816 10.4808 7.47499 10.5816 7.53726L10.6933 6.95221C10.5924 6.89015 10.3694 6.82788 10.1305 6.82788C9.38749 6.82788 9.00536 7.29383 9.00536 7.85298C9.00536 8.16891 9.19107 8.53645 9.67945 8.82647C9.98211 9.01808 10.1413 9.14219 10.1413 9.39585C10.1413 9.6236 9.97676 9.78929 9.65289 9.78929C9.45646 9.78929 9.20714 9.73247 9.06384 9.65473L8.96295 10.24H8.96273ZM11.622 10.3487H12.3173V7.48544H12.9543V6.85902H10.9903V7.48544H11.622V10.3487ZM14.8279 8.25165H14.0159V7.4493H14.8757V6.85902H13.3206V10.3487H14.9342V9.75838H14.0159V8.81602H14.8279V8.25165ZM15.4118 10.3332C15.5498 10.3539 15.7674 10.3746 15.9904 10.3746C16.4841 10.3746 16.8343 10.2607 17.0785 10.0379C17.3917 9.76883 17.5776 9.26651 17.5776 8.56236C17.5776 7.8582 17.4185 7.42317 17.1104 7.15405C16.8823 6.94698 16.5692 6.84334 16.1178 6.84334C15.842 6.84334 15.5871 6.86925 15.4118 6.91062V10.333V10.3332ZM16.1071 7.4027C16.1495 7.38724 16.1973 7.38724 16.2451 7.38724C16.6642 7.38724 16.8555 7.82206 16.8555 8.53667C16.8555 9.49971 16.5636 9.82065 16.2292 9.82065C16.1919 9.82065 16.1442 9.82065 16.1071 9.8102V7.4027Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81177 14.5083L8.93018 17.9925L14.4853 11.324L8.93018 15.7124L5.81177 14.5083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_8200",
    x1: 4.39181,
    y1: 0.993742,
    x2: 15.1322,
    y2: 19.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FED844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FDBA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FED844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FED844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B8792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFCC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_8200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrustedShield);
export default __webpack_public_path__ + "static/media/icon-trusted-shield.ebb9499f7dfee7d150307b821bca42d7.svg";
export { ForwardRef as ReactComponent };